import { atom } from 'jotai'
import { VideoData, VideoFullData } from '../interfaces'

export const mobileConnectAtom = atom<boolean>(false)

export const crossmintBuyAtom = atom<CrossmintBuy | undefined>(undefined)

export const crossmintSecondaryAtom = atom<CrossmintSecondary | undefined>(undefined)

export const checkoutAtom = atom<CheckoutArgs | undefined>(undefined)

export enum PurchaseType {
  PRIMARY,
  SECONDARY,
}

export enum SecondaryAction {
  LISTING,
  OFFER,
}

export interface CrossmintSecondary {
  type: SecondaryAction
  video: VideoData
}
export interface CrossmintBuy {
  purchaseType: PurchaseType
  video: VideoData
  creatorName: string
  price: string
  priceLamports: number
  tokenSize: number
  buyer: string
  seller: string
}

export type CheckoutArgs = {
  data: VideoFullData
  isLive: boolean
  allowlistAmount: number
  balance: number
  allowlistDiscount?: number
}
